var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "date",
      attrs: {
        label: _vm.label,
        prop: _vm.prop,
        rules: _vm.rules,
        required: _vm.required
      }
    },
    [
      _c("el-date-picker", {
        attrs: {
          type: "date",
          format: "yyyy/MM/dd",
          "value-format": "yyyy/MM/dd",
          "picker-options": _vm.datePickerOptions,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          autofocus: _vm.autofocus
        },
        on: { change: _vm.changeDate },
        model: {
          value: _vm.date,
          callback: function($$v) {
            _vm.date = $$v
          },
          expression: "date"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }